import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleFileSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#56A" opacity={0.88} />
      <path fill="#fff" d="M40 41V15a1 1 0 00-1-1H22l-6 6v21a1 1 0 001 1h22a1 1 0 001-1" />
      <path
        fill="#56A"
        fillRule="evenodd"
        d="M21.5 22a.5.5 0 00-.5.5v.7c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5zm-.5 4.7c0-.28.22-.5.5-.5h13c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5zm0 4.2c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v.7a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5z"
        clipRule="evenodd"
        opacity={0.88}
      />
      <path fill="#8F9DD6" fillRule="evenodd" d="M16 20l6-6v5a1 1 0 01-1 1z" clipRule="evenodd" />
    </svg>
  );
}

SvgPicCircleFileSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleFileSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleFileSelected svgRef={ref} {...props} />
));
export default ForwardRef;
